<template>
  <div class="modal_container" @click="fullCategory">
    <div class="image_modal" :style="`background-image: url('${actualCategory.url}')`"></div>
    <h3 class="modal_name">{{actualCategory.name}}</h3>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  computed:{
    ...mapState({
      showModal: state => state.category.showModal,
      actualCategory: state => state.category.actualCategory
    })
  },
  methods:{
    ...mapActions(['fullCategory'])
  }
}
</script>

<style scoped lang="scss">
.modal_container{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.315);
  flex-direction: column;
}
.image_modal{
  width: 350px;
  height: 350px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.modal_name{
  width: 350px;
  background: white;
}
@media (min-width: 1440px){
  .image_modal{
    width: 1200px;
    height: 700px;
  }
  .modal_name{
    width: 1200px;
  }
  .modal_container{
    background: rgba(0, 0, 0, 0.541);
  }
}
</style>